var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.375 2H28.9016L39.375 12.4733V39.5C39.375 41.5711 37.6961 43.25 35.625 43.25H9.375C7.30393 43.25 5.625 41.5711 5.625 39.5V5.75C5.625 3.67893 7.30393 2 9.375 2ZM24.375 5.75H9.375V39.5H35.625V16.875H28.125C26.0539 16.875 24.375 15.1961 24.375 13.125V5.75ZM28.125 6.52665V13.125H34.7233L28.125 6.52665Z",
    fill: "#2B391C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/fileIcon.706223f7a04aeea6f9df116eea1f7513.svg";
export { ForwardRef as ReactComponent };